<template>
  <div 
    v-if="promoItems.length > 0"
    class="ProductShippingPromo ProductShipping-cardsRowSmall"
  > 

    <div>
      <p class="ProductShippingPromo-title"><span>Les +</span> Mon Chauffagiste Privé</p>
      
      <div    
        v-for="(option, index) in promoItems"
        :key="index"
      >
        <div
          class="ProductShippingPromo-row"
        >
          <p>
            {{ option.name }}
            <ToolTip v-if="option.short_description" :text="option.short_description" :classProps="'left'"></ToolTip>
          </p>

          <ProductPriceRecap
            v-if="option.originalPrice"
            :originalPrice="option.originalPrice"
            :specialPrice="option.final_price[productCurrentTva]"
          ></ProductPriceRecap>

          <ProductPriceRecap
            v-else-if="!option.originalPrice && option.price"
            :originalPrice="option.price"
          ></ProductPriceRecap>

          <ProductPriceRecap
            v-else
            :originalPrice="option.final_price[productCurrentTva]"
          ></ProductPriceRecap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductPriceRecap from "@/includes/Product/ProductPrice/ProductPriceRecap.vue";
import ToolTip from "@/components/ToolTip/ToolTip.vue";
import { mapGetters } from "vuex";

import "@/includes/Product/ProductShippingPromo/ProductShippingPromo.scss";

export default {
  name: "ProductShippingPromo",

  data() {
    return {
      promoItems: [],
      showDetails : false,
    };
  },

  components: {
    ProductPriceRecap,
    ToolTip,
  },

  computed: {
    ...mapGetters({
      productOptions: "getProductOptions",
      additionalProduct: "getProductAdditionalProduct",
      productCurrentTva: "getProductTVAForCurrentDelivery",
      preprendCartCurrentSelectedDelivery: "getPreprendCartCurrentSelectedDelivery",
    }),
  },
  watch: {
    preprendCartCurrentSelectedDelivery() {   
      this.getPromoItems();
    },
  },
  methods: {
    getPromoItems() {

      this.promoItems = [];
      if(this.additionalProduct){

        let relatedProducts = (this.preprendCartCurrentSelectedDelivery == "delivery_only" ? this.additionalProduct.delivery_related_product : this.additionalProduct.standard_related_product);

        relatedProducts.forEach(product => {
          this.promoItems.push(product)
        });
      }
      
      //Cobranding
      if(this.productOptions.referrer_discount && (this.preprendCartCurrentSelectedDelivery != "delivery_only" || this.productOptions.referrer_discount.applicable_on_delivery_only === true)) {
        this.promoItems.push(this.productOptions.referrer_discount)
      }
    },

    toggleOpen() {
      this.showDetails = !this.showDetails
    }
  },

  mounted() {
    this.getPromoItems()
  },
  
};
</script>
